import { apiClient } from "./apiClient";

export const accountApi = {
  sessions: () => apiClient.get("/account/sessions").then((r) => r.data),
  revokeSession: (sessionId) => apiClient.post("/account/sessions/revoke", { session_id: sessionId }).then((r) => r.data),
  generateBackupCodes: () => apiClient.post("/account/backup-codes").then((r) => r.data),
  setSecurityQuestions: (answers) => apiClient.post("/account/security-questions", { answers }).then((r) => r.data),

  // The state registration number (#274). Read and written against the
  // ACCOUNT, not the caller -- a team member filing a report files it for
  // the apiary. An empty string clears it, which somebody whose
  // registration lapsed needs to be able to do.
  // Name and registration together (#274, #286): one "about this apiary"
  // call rather than two endpoints differing only in which column they
  // touch. The PUT is PARTIAL -- send only what changed, or a form that
  // posts one field blanks the other.
  getApiary: () => apiClient.get("/account/apiary").then((r) => r.data),
  setApiary: (fields) => apiClient.put("/account/apiary", fields).then((r) => r.data),

  // Role management (Admin/Editor/Viewer/Limited) -- backs the Team Dashboard's Role Management section.
  listShares: () => apiClient.get("/account/shares").then((r) => r.data),
  // The date span is optional and PAID (#187). Omitting both is a
  // permanent member, which is what every share was before V052 and what a
  // Free-tier account gets.
  inviteShare: (sharedEmail, role, accessFrom, accessUntil) =>
    apiClient
      .post("/account/shares", {
        shared_email: sharedEmail,
        role,
        ...(accessFrom ? { access_from: accessFrom } : {}),
        ...(accessUntil ? { access_until: accessUntil } : {}),
      })
      .then((r) => r.data),
  // canSeeFinancials is OPTIONAL and omitted by default (#235). The server
  // treats an absent field as "leave it alone", so a caller that only knows
  // about roles cannot silently hand somebody the books back.
  updateShareRole: (shareId, role, canSeeFinancials) =>
    apiClient
      .put(`/account/shares/${shareId}`, {
        role,
        ...(canSeeFinancials === undefined ? {} : { can_see_financials: canSeeFinancials }),
      })
      .then((r) => r.data),
  approveShare: (shareId) => apiClient.post(`/account/shares/${shareId}/approve`).then((r) => r.data),
  revokeShare: (shareId) => apiClient.post(`/account/shares/${shareId}/revoke`).then((r) => r.data),
  // #188. Removal was always a soft revoke, so this restores the member
  // with the role and site assignments they already had.
  reactivateShare: (shareId) => apiClient.post(`/account/shares/${shareId}/reactivate`).then((r) => r.data),

  // Site-specific access for the 'Limited' role (V027).
  listShareSites: (shareId) => apiClient.get(`/account/shares/${shareId}/sites`).then((r) => r.data),
  setShareSites: (shareId, siteIds) => apiClient.put(`/account/shares/${shareId}/sites`, { site_ids: siteIds }).then((r) => r.data),

  /*
   * Your data: the two rights the app has to honour under GDPR and the
   * equivalent US state laws, and the pair #284 found had no client at
   * all. The endpoints have existed the whole time and the admin console
   * has a queue for REVIEWING requests -- there was simply no way for a
   * person to make one.
   *
   * Export is synchronous and returns the whole bundle in the response
   * body, so there is no polling and nothing to wait for. Deletion is
   * NOT: it creates a pending request an admin reviews, because an
   * account can own hives and records shared with a team.
   */
  requestDataExport: () =>
    apiClient.post("/account/gdpr-request", { request_type: "Export" }).then((r) => r.data),

  requestAccountDeletion: () =>
    apiClient.post("/account/gdpr-request", { request_type: "Deletion" }).then((r) => r.data),

  dataRequests: () => apiClient.get("/account/gdpr-requests").then((r) => r.data),
};
